import _styled from "styled-components";
type Props = {
  message: string;
};
export function FieldError(props: Props) {
  const {
    message
  } = props;
  return <_StyledSpan role="alert" dangerouslySetInnerHTML={{
    __html: message
  }} />;
}
var _StyledSpan = /*#__PURE__*/_styled("span").withConfig({
  displayName: "field-error___StyledSpan",
  componentId: "sc-uszavt-0"
})({
  "position": "absolute",
  "bottom": "0",
  "left": "0",
  "display": "block",
  "--tw-translate-y": "100%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "alignSelf": "flex-start",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
  "paddingLeft": "0.8rem",
  "paddingRight": "0.8rem",
  "paddingTop": "0.4rem",
  "paddingBottom": "0.4rem",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "color": "var(--color-functional-error)"
});